export enum GoogleAnalyticsEvent {
  // KYB
  upgrade_account,
  click_verify_business,
  click_sidebar_verify_business,
  kyb_section_business_type,
  kyb_section_choose_product,
  kyb_section_business_information,
  kyb_section_bank_account,
  kyb_section_legal_document,
  kyb_section_identity_document,
  kyb_section_tnc,
  approve_vida_user_consent,
  save_progress,
  click_close,
  submit_kyb_form,
}
